export default __webpack_public_path__ + "static/media/no_actions.67a55e72.svg";